import { render, staticRenderFns } from "./callExample.vue?vue&type=template&id=ffb6abfe&scoped=true"
import script from "./callExample.vue?vue&type=script&lang=js"
export * from "./callExample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.6_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6._v3ikegxpyohwicxz2xngozg43i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb6abfe",
  null
  
)

export default component.exports